import { useSearchParams } from "react-router";

export const useSearchQuery = () => {
    const [searchParams, setSearchParams] = useSearchParams();


    const handleSetSearchParams = (query) => {
        if (query === "function") {
            setSearchParams(prev => query(Object.fromEntries(prev)));
            return;
        }

        setSearchParams(query);
    }

    return [Object.fromEntries(searchParams), handleSetSearchParams]
}